var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Blog-container"},[_c('Layout',[_c('BlogList'),_c('template',{slot:"right"},[_c('BlogCategory')],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }